import Select from 'react-select';
import { CreativeType } from '../../../data/__generated__/globalTypes';
import React from 'react';
import { useForecastingSettings } from '../../ForecastingContextProvider';
import { usePrimaryForecastingState } from '../ForecastingPanel';

export default function CreativeTypes() {
    const { forecastingSettings, updateForecastingSetting } = useForecastingSettings();
    const { isPrimaryForecastingLoading } = usePrimaryForecastingState();

    return (
        <div className='mt-4 w-80'>
            <label
                htmlFor='creativeTypes'
                className='block text-sm font-medium text-gray-700'
            >
                Creative types
            </label>
            <Select
                key={'creativeTypes'}
                isDisabled={isPrimaryForecastingLoading || !forecastingSettings.ssp}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                isMulti
                name='creativeTypes'
                className='basic-multi-select'
                classNamePrefix='select'
                onChange={newValue => updateForecastingSetting({ creativeTypes: newValue.map(it => it.value) })}
                options={[CreativeType.VIDEO, CreativeType.DISPLAY, CreativeType.AUDIO].map(it => ({
                    value: it,
                    label: `${it.charAt(0)}${it.slice(1).toLowerCase()}`
                }))}
                defaultValue={forecastingSettings.creativeTypes?.map(it => ({
                    value: it,
                    label: `${it.charAt(0)}${it.slice(1).toLowerCase()}`
                }))}
            />
        </div>
    );
}
